let primaryColor = "#318EB8";
let secondaryColor = "#0075A8";
let tercaryColor = "#004D71";

let gradientColorPrimary = "#6C207E";
let gradientColorSecondary = "#6C207E";
let hoverBackgroundColor = "#fff";
let hoverColor = "#6C207E";
let bodyColor = "#fff";
let bodyBgColor;
let bodyAltColor = "#fff";
let footerBackgroundColor = "";
let footerBackground =
  "linear-gradient(0deg, rgba(0,156,180,1) 0%, rgba(35,35,75,1) 35%);";
let footerLinkColor = tercaryColor;
let footerColor = primaryColor;
let headerBgColor = "#F9F9F9";
let buttonBgColor = bodyColor;

switch (process.env.REACT_APP_SITE) {
  case "psy":
    primaryColor = "#009cb4";
    secondaryColor = "#52ae32";
    bodyAltColor = secondaryColor;
    tercaryColor = "transparent";
    bodyBgColor = "#23234b";
    headerBgColor = null;
    buttonBgColor = primaryColor;
    footerLinkColor = primaryColor;
    footerColor = primaryColor;
    break;
  default:
    break;
}

export {
  primaryColor,
  secondaryColor,
  tercaryColor,
  gradientColorPrimary,
  gradientColorSecondary,
  hoverBackgroundColor,
  hoverColor,
  bodyColor,
  bodyAltColor,
  bodyBgColor,
  footerBackgroundColor,
  footerBackground,
  footerLinkColor,
  footerColor,
  headerBgColor,
  buttonBgColor,
};



// WEBPACK FOOTER //
// ./src/helpers/colors.js